import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { editProduct,addNewProductimg } from "../../../services/MasterApiServices";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import EditProductProfile from "./Product/EditProductPrtofile";
import EditProductSection from "./Product/EditProductSection";
import EditOtherDescription from "./Product/EditProductOtherDiscription";
// import { ProductClass } from "../../../core/json/ProductClass";
import toast from "react-hot-toast";
import { TaxClass } from "../../../core/json/TaxClass";
import { ComboProductDetail } from "../../../core/json/ComboProductDetail";
import {fetchProduct, fetchProductAll} from "../../../redux/userSetting";
import { ProductPos } from "../../../core/json/ProductPos";
 
const EditProduct = ({ data }) => {
  const {
    register,
    formState: { errors, isValid, isDirty },
    handleSubmit,
    setValue,
    getValues,
    watch,
    control,
    reset,
    trigger,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      items: [{ name: "", maxItems: "", comments: "" }],
    },
  });
    const [productImages, setProductImages] = useState([]);
  const [thumbnailImage, setThumbnailImage] = useState("");
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.userauth);
  const {
    sectionList,
    taxList,
    categoryList,
    deliveyTypes,
    productList,
    unitList,
    groupList,
  } = useSelector((state) => state.usersetting);
  const { branch } = useSelector((state) => state.branchlist);
  const comboType = deliveyTypes?.find((type) => type.name === "Combo"); // Find Combo type
  const COMBO_TYPE_ID = comboType?.guid; // Get Combo type GUID
  const [tabIndex, setTabIndex] = useState(0);
  useEffect(() => {
    resetmodal();
    setTabIndex(0);
  }, [data, branch]);
  function resetmodal() {

    // let retailRateToShow = data?.retailRate; // Start with the saved value from DB

    // // If tax was included, recalculate the original user-entered value
    // if (data?.isSalesTaxIncludedInPrice && data?.taxID) {
    //   const taxRateObj = taxList.find((tax) => tax.guid === data.taxID);
    //   const taxRate = taxRateObj ? parseFloat(taxRateObj.percentage) : 0;
      
    //   if (taxRate > 0) {
    //     retailRateToShow = data.retailRate * (1 + taxRate / 100); 
    //   }
    // }
  
  
    setValue("profile", {
      name: data?.name,
      shortName: data?.shortName,
      prodCode:data?.prodCode,
      // barCode: data?.barcode,
      avgCost: data?.avgCost,
      retailRate: data?.retailRate,
      wsRate: data?.wsRate,
      stockTypeID: data?.stockTypeID,
      isSalesTaxIncludedInPrice: data?.isSalesTaxIncludedInPrice,
      isPurchaseTaxIncludedInPrice: data?.isPurchaseTaxIncludedInPrice,
      ubc:data?.ubc,
      sbc:data?.sbc,
      // isActive: data?.isActive,
      categoryID: data?.categoryID,
      itemTypeID: data?.itemTypeID,
      subGroupID: data?.subGroupID,
      unitID: data?.unitID,
      taxID:data?.taxID,
    
    });
    // Transform the existing data to a mapped array
    // const sectionwise =
    //   data?.sectionWiseProductDetailList?.map((e) => ({
    //     IsActive: e.isActive,
    //     Section: e.section.guid,
    //     Price: e.price,
    //     Tax: e.tax.guid,
    //     IsTaxIncludedInPrice: e.isTaxIncludedInPrice,
    //   })) || [];
 
    // Find sections in `sectionList` not present in `sectionWiseProductDetailList`
    // const additionalSections =
    //   sectionList
    //     ?.filter(
    //       (e) =>
    //         !data?.sectionWiseProductDetailList?.some(
    //           (item) => item.section.guid === e.guid
    //         )
    //     )
    //     ?.map((e) => ({
    //       IsActive: false,
    //       Section: e.guid,
    //       Price: null,
    //       Tax: null,
    //       IsTaxIncludedInPrice: false,
    //     })) || [];
 
    // Combine both arrays
    // const combinedSections = [...sectionwise, ...additionalSections];
 
    // Set the combined result in the form or state
    // setValue("sectionWiseProductDetailList", combinedSections);
 
    // const comboProductDetail = data?.comboProductDetail?.map((e) => ({
    //   sideChoiceNumber: e.sideChoiceNumber,
    //   name: e.product.guid,
    //   maxItems: e.quantity,
    // }));
    // setValue("items", comboProductDetail);
 
   
    setValue("otherDescription", {
      shortDescription: data?.shortDescription,
      manufactureID: data?.manufactureID,
      minPrice: data?.minPrice,
      minQty: data?.minQty,
      maxQty: data?.maxQty,
      // isSalesTaxIncludedInPrice: data?.isSalesTaxIncludedInPrice,
      // isPurchaseTaxIncludedInPrice: data?.isPurchaseTaxIncludedInPrice,
      reorderLevel: data?.reorderLevel,
      reorderQty: data?.reorderQty,
      isMenuItem: data?.isMenuItem,
      thumbImage: data?.thumbImage,
      strProdImage: data?.strProdImage,
    });
  }
 
  console.log(data,"dataaaaaaasssssss");
 
 
  const handleUpdateProduct = async (formData) => {
    // const taxobj = new TaxClass();
 
    // const sectionWiseProductDetailList =
      // getValues()?.sectionWiseProductDetailList?.map((e) => ({
      //   Section: sectionList?.find((item) => item.guid == e.Section),
      //   IsActive: e.IsActive,
      //   IsTaxIncludedInPrice: e.IsTaxIncludedInPrice,
      //   Price: Number(e.Price),
      //   tax: e.Tax ? taxList?.find((item) => item.guid == e.Tax) : taxobj,
      // }));
    // const objcombodetail = new ComboProductDetail();
    // const ComboProductarray =
    //   watch().profile?.type === COMBO_TYPE_ID
    //     ? formData?.profile.items?.map((e, i) => ({
    //         sideChoiceNumber: i,
    //         products: productList?.filter((item) =>
    //           e?.name?.some((pro) => item.guid === pro.value)
    //         ),
    //         quantity: e.maxItems,
    //       }))
    //     : null;
    // const FixedItem = ComboProductarray?.[0] || null;
    // const SideChoices = ComboProductarray?.slice(1) || [];
    // objcombodetail.FixedItem = FixedItem;
    // objcombodetail.SideChoices = SideChoices;
    const objproduct = new ProductPos();
    objproduct.id = data.id;
    objproduct.guid = data.guid;
    objproduct.ProdCode = formData?.profile.prodCode;
    objproduct.Description1= formData?.profile.name;
    objproduct.ShortName = formData?.profile.shortName;
    objproduct.StockTypeID = formData?.profile.stockTypeID;
    objproduct.ModifiedDate= formData.ModifiedDate;
    // objproduct.barCode = formData?.profile.barCode;
    objproduct.CategoryID =  formData?.profile.categoryID
    objproduct.TaxID =  formData?.profile.taxID
    objproduct.ItemTypeID= formData?.profile.itemTypeID
   
    objproduct.SubGroupID =formData?.profile.subGroupID
   
    objproduct.UnitID =  formData?.profile.unitID
   
    objproduct.AvgCost = parseFloat(formData?.profile.avgCost);
   // objproduct.RetailRate = parseFloat(formData?.profile.retailRate);
  // objproduct.RetailRate = formData?.profile.retailRate;

      // Reverse Tax Calculation
  // const taxID = formData?.profile.taxID;
  // const taxRateObj = taxList.find((tax) => tax.guid === taxID);
  // const taxRate = taxRateObj ? parseFloat(taxRateObj.percentage) : 0;

  // if (formData?.profile.isSalesTaxIncludedInPrice && taxRate > 0) {
  //   objproduct.RetailRate = parseFloat(formData?.profile.retailRate) / (1 + taxRate / 100);
  // } else {
  //   objproduct.RetailRate = parseFloat(formData?.profile.retailRate);
  // }
    // Reverse Tax Calculation only when sending data to the backend
    const taxID = formData?.profile.taxID;
    const taxRateObj = taxList.find((tax) => tax.guid === taxID);
    const taxRate = taxRateObj ? parseFloat(taxRateObj.percentage) : 0;
  
    let retailRateToSend = parseFloat(formData?.profile.retailRate);
    if (formData?.profile.isSalesTaxIncludedInPrice && taxRate > 0) {
      retailRateToSend = retailRateToSend / (1 + taxRate / 100);
    }
    objproduct.RetailRate = retailRateToSend;

    objproduct.WSRate = formData?.profile.wsRate;
    objproduct.IsSalesTaxIncludedInPrice = formData?.profile.isSalesTaxIncludedInPrice;
    objproduct.IsPurchaseTaxIncludedInPrice = formData?.profile.isPurchaseTaxIncludedInPrice;
    objproduct.Ubc = formData?.profile.ubc;
    objproduct.Sbc = formData?.profile.sbc;
    objproduct.isActive = formData?.profile.isActive;
    // objproduct.sectionWiseProductDetailList = sectionWiseProductDetailList;
    // objproduct.comboProductDetail =
    //   formData?.profile.type === COMBO_TYPE_ID ? objcombodetail : null;
    objproduct.ShortDescription = formData?.otherDescription.shortDescription;
    objproduct.ManufactureID = formData?.otherDescription.manufactureID;
    objproduct.MinPrice = formData?.otherDescription.minPrice;
    // objproduct.IsSalesTaxIncludedInPrice = formData?.profile.isSalesTaxIncludedInPrice;
    // objproduct.IsPurchaseTaxIncludedInPrice= formData?.profile.isPurchaseTaxIncludedInPrice;
    objproduct.MinQty = formData?.otherDescription.minQty ;
    objproduct.MaxQty = formData?.otherDescription.maxQty ;
    objproduct.ReorderLevel = formData?.otherDescription.reorderLevel;
    objproduct.ReorderQty = formData?.otherDescription.reorderQty ;
    objproduct.MinQty = formData?.otherDescription.minQty;
    objproduct.Branch = branch;
    objproduct.IsMenuItem = formData?.otherDescription.isMenuItem;
    objproduct.productImagesList = [];
    objproduct.updatedUser = `{${userId?.id}}`; //"{9b57619d-63c8-4e27-9a59-639f0c80e4a1}"; //userId
 
    console.log(objproduct.RetailRate, "objproduct retail rate");
  //   try {

  //     const response = await editProduct(objproduct);
 
  //     if (response == true) {
  //       toast.success("Success");
  //       closemodal();
  //       dispatch(fetchProduct(branch));
  //     } else if (response == false) {
  //       toast.error("false");
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.Message);
  //     console.error("Error handling :", error);
  //   }
  // };
  

    const formDataToSend = new FormData();
  
      // 1. Append product data as string
      formDataToSend.append("product", JSON.stringify(objproduct));
      console.log(formDataToSend,"formdatatosenddddddd");
  
      // 2. Append files
      console.log(thumbnailImage,"thumbnailDATATOSEND");
      if (thumbnailImage) {
        formDataToSend.append("thumbimg", thumbnailImage);
      }
      
      if (Array.isArray(productImages)) {
        productImages.forEach((file) => {
          formDataToSend.append("productImage", file);
        });
      } else if (productImages) {
        formDataToSend.append("productImage", productImages);
      }
      
  
  
  console.log(objproduct,"objproducttttttttttt");
  
  
      try {
        const response = await addNewProductimg(formDataToSend);
      
        if (response === true) {
          closemodal();
          dispatch(fetchProduct(branch));
          toast.success("Success");
        } else {
          toast.error("Upload failed");
        }
      } catch (error) {
        toast.error(error?.response?.data?.Message || "Upload failed");
        console.error("Error handling:", error);
      }
      
      // Logging for debug
      for (let pair of formDataToSend.entries()) {
        console.log(`${pair[0]}:`, pair[1]);
      }
    };    
  
  const closeButtonRef = useRef();
 
  const closemodal = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
  };
 
  return (
    <div>
      <div className="modal fade" tabIndex="-1" id="edit-product">
        <div className="modal-dialog purchase modal-dialog-centered stock-adjust-modal">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Product</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeButtonRef}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <form onSubmit={handleSubmit(handleUpdateProduct)}>
                  <div className="branch-tabs col-12 align-items-center justify-content-between">
                    <Tabs
                      selectedIndex={tabIndex}
                      onSelect={async (index) => {
                        const isValid = await trigger(); // Validate current tab fields
                        if (isValid) {
                          setTabIndex(index); // Allow tab switch if valid
                        } else {
                          alert(
                            "Please fix the errors in this tab before switching."
                          );
                        }
                      }}
                    >
                      <TabList>
                        <Tab>Profile</Tab>
                        {/* <Tab>Section Price</Tab> */}
                        <Tab>Other Details</Tab>
                      </TabList>
                      <TabPanel>
                        <EditProductProfile
                          register={register}
                          watch={watch}
                          control={control}
                          errors={errors}
                          productName={watch("profile.name")}
                          setValue={setValue}
                        />
                      </TabPanel>
                      {/* <TabPanel>
                        <EditProductSection
                          register={register}
                          getValues={getValues}
                          errors={errors}
                        />
                      </TabPanel> */}
                      <TabPanel>
                        <EditOtherDescription
                                productImages={productImages}
                                setProductImages={setProductImages}
                                thumbnailImage={thumbnailImage}
                                setThumbnailImage={setThumbnailImage}
                          register={register}
                          errors={errors}
                          // setValue={setValue}
                          watch={watch}
                          productData={data}
                          // productName={watch("profile.name")}
                        />
                      </TabPanel>
                    </Tabs>
                  </div>
                  <div className="col-lg-12">
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        onClick={() => {
                          resetmodal();
                          reset(); // Reset react-hook-form
                          setTabIndex(0); // Reset to the first tab
                        }}
                      >
                        Reset
                      </button>
                      <button
                        type="submit"
                        className="btn btn-submit"
                        disabled={!!Object.keys(errors || {}).length} // Disable if there are errors
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default EditProduct;
 